import React from 'react';
import PendingPage from '../../components/shared/Pending';
export default function Support() { return <PendingPage title="Support" description="Contact the StayEasy team." note="Support ticket endpoints aren't part of the host API yet. Please email support@stayeasy.io meanwhile." />; }
